module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution1_1-1d6e8ae00df2c8c7995decdb74da885f.png";